import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { audiences } from '../../data/home';
import { fadeUp } from '../../utils/motion';
export function HomeAudiences() {
  return <section className="bg-white py-20 lg:py-28" data-id="element-361" data-mp="2ury50wv2dsia">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-362" data-mp="2uuu1shv6eb55">
        <div className="lg:col-span-5" data-id="element-363" data-mp="2253na7pmt78i">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-364" data-mp="22657p2sjf62w">
            Built for complex, consequential work
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-365" data-mp="2c0f1mox4ocfq">
            SyNeural works with research organizations, educators, civil society
            groups, employers, and public institutions. Each faces different
            questions, but all need reliable knowledge and the human capacity to
            use it well.
          </p>
        </div>
        <ul className="lg:col-span-7 border-t border-line self-start" data-id="element-366" data-mp="p1vuasz8zgmv">
          {audiences.map(audience => <li key={audience.label} className="border-b border-line" data-id="element-367" data-mp="tyvw2rp2dx86">
              <a href={audience.link} className="group flex items-center justify-between py-5 text-xl font-heading font-semibold text-ink-dark hover:text-navy transition-colors duration-150" data-id="element-368" data-mp="yyqr97fvh8z1">
                {audience.label}
                <ArrowRight size={18} className="text-ink-muted group-hover:text-navy group-hover:translate-x-1 transition-transform duration-150" data-id="element-369" data-mp="b9pamwwvyrio" />
              </a>
            </li>)}
        </ul>
      </motion.div>
    </section>;
}